module.exports = __webpack_public_path__ + "src/assets/img/share/tips/conscientiousness/58b84f097246f810ccfc18a7fad6a288.png";